const ENBusiness = {
	"Adicionar Empresa": "Add Company",
	"Alterar Empresa": "Change Company",
	"CNPJ é requerido": "CNPJ is required",
	"CNPJ inválido": "Invalid CNPJ",
	"CNPJ já está em uso": "CNPJ already in use",
	"Deseja realmente excluir a empresa": "Do you really want to delete the company",
	"Digite o nome da empresa para excluí-la": "Enter the company name to delete it",
	"Empresa adicionada com sucesso": "Company successfully added",
	"Empresa alterada com sucesso": "Company successfully changed",
	"Empresa excluída com sucesso": "Company successfully deleted",
	"Empresas": "Companies",
	"Erro ao excluir empresa": "Error deleting company",
	"Erro ao trocar imagem da empresa": "Error changing company image",
	"Exclusão de empresa": "Delete company",
	"Imagem da empresa atualizada com sucesso": "Company image updated successfully",
	"Imagem da empresa": "Company image",
	"Nome da empresa não confere": "Company name does not match",
	"Nome Fantasia": "Company Fantasy Name",
	"Nova Empresa": "New Company",
	"Número de empresas excede a quantidade máxima do contrato": "Number of companies exceeded maximum contract quantity",
	"Razão Social": "Company Name",
	"Você não possui permissão para excluir esta empresa": "You do not have permission to delete this company"
};

export default ENBusiness;
